import { ResponsivePie } from "@nivo/pie";
import { GovPlanSecretaryProject } from "../../../model/project";
import Masks from "../../../../../../../../shared/utils/mask.utils";

export const GovPlanSecretaryProjectBudgetChart = ({
    project,
}: {
    project: GovPlanSecretaryProject;
}) => {
    const budget = project.roadmap
        .sort((a, b) => (a.status > b.status ? 1 : 0))
        .map((it) => ({
            id: it.name,
            label: it.name,
            value: it.amount,
        }));

    if (project.remainingBudget > 0)
        budget.push({
            id: "Montante disponível",
            label: "Montante disponível",
            value: project.remainingBudget,
        });

    return (
        <ResponsivePie
            data={budget}
            margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
            innerRadius={0.5}
            padAngle={2}
            cornerRadius={3}
            borderWidth={1}
            borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
            arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
            arcLabel={({ value }) => Masks.currency(value)}
            tooltip={() => null}
            legends={[
                {
                    anchor: "bottom",
                    direction: "row",
                    justify: false,
                    translateX: 0,
                    translateY: 56,
                    itemsSpacing: 0,
                    itemWidth: 100,
                    itemHeight: 18,
                    itemTextColor: "#999",
                    itemDirection: "left-to-right",
                    itemOpacity: 1,
                    symbolSize: 18,
                    symbolShape: "circle",
                },
            ]}
        />
    );
};
